var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectBalancingBuilding } from "../../../../../../balancingSelectors/selectBalancingBuildings";
import { IdStyles } from "../../../../../../less/IdStyles";
import { ReplacementLoca } from "../../../../../../utils/i18n/ReplacementLoca";
import { utilLoca } from "../../../../../../utils/i18n/utilLoca";
import { utilBuildings } from "../../../../../../utils/utilBuildings";
import { utilNumber } from "../../../../../../utils/utilNumber";
import { actionBeginBuyWithGoldProcess } from "../../../../../buy-with-gold/actionBuyWithGold";
import { IconBuilding } from "../../../../../generic/common/icon-building/IconBuilding";
import { IdIconBuildingContext } from "../../../../../generic/common/icon-building/IdIconBuildingContext";
import { Icon } from "../../../../../generic/icon/Icon";
import { IdIcon } from "../../../../../generic/icon/IdIcon";
import { actionShowMeQuestTaskHaveBuildings } from "../../../../../show-me/actionShowMe";
import { ButtonQuestShowMe } from "../ButtonQuestShowMe";
import { QuestSkipButton } from "../QuestSkipButton";
import { QuestTask } from "../QuestTask";
var _QuestTaskHaveBuilding = function (props) {
    var tasks = props.tasks, quest = props.quest, questInfoTasks = props.questInfoTasks, onTrySkip = props.onTrySkip, onClickShowMe = props.onClickShowMe;
    var task = tasks;
    var list = task.map(function (value) {
        var requiredInfoTask = questInfoTasks.find(function (val) { return val.index === value.index; });
        var requiredBuilding = selectBalancingBuilding(value.buildingId);
        var buildingCount = requiredInfoTask.amount || 0;
        var buildingShopCategoryTypeTask = value.buildingId === undefined && value.shopCategory != undefined;
        var locaReplacements = new Map([
            [ReplacementLoca.amount, utilNumber.format(value.amount)],
            [ReplacementLoca.level, utilNumber.format(value.stage)],
            [
                ReplacementLoca.target,
                requiredBuilding ? utilLoca.get(requiredBuilding.locaKey) : "",
            ],
        ]);
        var icon = React.createElement(Icon, { icon: IdIcon.DecorationsIcn, styleId: IdStyles.IconExtraLarge });
        if (!buildingShopCategoryTypeTask) {
            var level = utilBuildings.getVisualLevel({
                balancing: requiredBuilding,
                proto: {
                    stage: value.stage,
                },
            });
            icon = (React.createElement(IconBuilding, { level: level, buildingName: requiredBuilding.name, context: IdIconBuildingContext.QuestsTaskRequirement }));
        }
        var taskProps = {
            currentAmount: buildingCount,
            icon: icon,
            locaKey: value.locaKey,
            locaReplacements: locaReplacements,
            requiredAmount: value.amount,
            taskCompleted: false,
        };
        var skipButtonProps = {
            currentAmount: buildingCount,
            onTrySkip: onTrySkip,
            questId: quest.id,
            requiredAmount: value.amount,
            skipCost: value.skipCost,
            taskIndex: value.index,
        };
        return (React.createElement(QuestTask, __assign({ key: value.locaKey + "_" + icon }, taskProps),
            React.createElement(QuestSkipButton, __assign({}, skipButtonProps)),
            React.createElement(ButtonQuestShowMe, { onClick: function () { return onClickShowMe(value); }, questTask: value })));
    });
    return React.createElement("div", { key: "haveBuilding" }, list);
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onClickShowMe: actionShowMeQuestTaskHaveBuildings,
        onTrySkip: actionBeginBuyWithGoldProcess,
    }, dispatch);
};
export var QuestTaskHaveBuilding = connect(undefined, mapDispatch)(_QuestTaskHaveBuilding);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/questTaskHaveBuilding/QuestTaskHaveBuilding.tsx
// module id = 2671
// module chunks = 3